const FYOR_GIFT_VARIANT_ID = 42466268119142;
const FYOR_GIFT_PROPERTY_NAME = '_automatic_free_gift';

if (!customElements.get('product-form-component')) {
  customElements.define(
    'product-form-component',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.init();
      }

      init() {
        this.form = this.querySelector('form');
        if (!this.form) return;

        this.variantIdInput.disabled = false;
        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart = document.querySelector('cart-drawer');

        this.submitButton = this.form.querySelector(
          '.add-to-cart-button'
        );

        this.submitButtonText = this.submitButton
          ? this.submitButton.querySelector('span')
          : null;

        this.checkbox = this.form.querySelector(
          '[id^="agree_condition-"]'
        );

        this.buyItNowButton = this.form.querySelector(
          '.shopify-payment-button'
        );

        if (
          document.querySelector('cart-drawer') &&
          this.submitButton
        ) {
          this.submitButton.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }

        this.hideErrors =
          this.dataset.hideErrors === 'true';

        this.initAgreeCondition();
        this.setupErrorSync();
      }

      setupErrorSync() {
        try {
          const productInfo = this.closest('product-info');

          const sectionId =
            productInfo?.dataset.section ||
            productInfo?.dataset.originalSection;

          if (!sectionId) return;

          const stickyATC = document.querySelector(
            `sticky-atc[data-sticky-section-id="${sectionId}"]`
          );

          if (!stickyATC) return;

          const mainErrorWrapper = this.querySelector(
            '.product-form__error-message-wrapper'
          );

          const stickyErrorWrapper =
            stickyATC.querySelector(
              '.product-form__error-message-wrapper'
            );

          if (
            !mainErrorWrapper ||
            !stickyErrorWrapper
          ) {
            return;
          }

          const syncFromMain = () => {
            const isVisible =
              !mainErrorWrapper.hasAttribute('hidden');

            const errorMessage =
              mainErrorWrapper.querySelector(
                '.product-form__error-message'
              )?.textContent;

            stickyErrorWrapper.toggleAttribute(
              'hidden',
              !isVisible || !errorMessage
            );

            if (isVisible && errorMessage) {
              const stickyErrorMessage =
                stickyErrorWrapper.querySelector(
                  '.product-form__error-message'
                );

              if (stickyErrorMessage) {
                stickyErrorMessage.textContent =
                  errorMessage;
              }
            }
          };

          syncFromMain();

          this._errorObserver = new MutationObserver(
            syncFromMain
          );

          this._errorObserver.observe(
            mainErrorWrapper,
            {
              attributes: true,
              attributeFilter: ['hidden'],
              childList: true,
              subtree: true,
            }
          );

          this.cartErrorUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartError,
            () => {
              syncFromMain();
            }
          );
        } catch (error) {
          console.warn(
            '[Product Form] Error sync failed:',
            error
          );
        }
      }

      initAgreeCondition() {
        if (
          !this.checkbox ||
          !this.buyItNowButton
        ) {
          return;
        }

        this.buyItNowButton.classList.add(
          'disabled'
        );

        this.checkbox.addEventListener(
          'change',
          () => {
            this.buyItNowButton.classList.toggle(
              'disabled',
              !this.checkbox.checked
            );
          }
        );

        this.form.addEventListener(
          'submit',
          (event) => {
            if (!this.checkbox.checked) {
              event.preventDefault();
            }
          }
        );
      }

      onSubmitHandler(event) {
        event.preventDefault();

        if (!this.submitButton) return;

        if (
          this.submitButton.getAttribute(
            'aria-disabled'
          ) === 'true'
        ) {
          return;
        }

        /*
         * Ella may load or move the cart drawer
         * after the product form initializes.
         * Always find the live drawer again.
         */
        this.cart =
          document.querySelector('cart-drawer') ||
          this.cart;

        if (this.cart) {
          this.submitButton.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute(
          'aria-disabled',
          true
        );

        this.submitButton.classList.add(
          'loading'
        );

        const loadingSpinner =
          this.submitButton.querySelector(
            '.loading__spinner'
          );

        loadingSpinner?.classList.remove(
          'hidden'
        );

        const productInfo =
          this.closest('product-info');

        const sectionId =
          productInfo?.dataset.section ||
          productInfo?.dataset.originalSection;

        const stickyAddButton = sectionId
          ? document.getElementById(
              `StickyCart-ProductSubmitButton-${sectionId}`
            )
          : null;

        const stickyLoadingSpinner =
          stickyAddButton?.querySelector(
            '.loading__spinner'
          );

        if (
          stickyAddButton &&
          stickyLoadingSpinner
        ) {
          stickyAddButton.classList.add(
            'loading'
          );

          stickyLoadingSpinner.classList.remove(
            'hidden'
          );
        }

        const config = fetchConfig(
          'javascript'
        );

        config.headers['X-Requested-With'] =
          'XMLHttpRequest';

        delete config.headers['Content-Type'];

        const formData = new FormData(
          this.form
        );

        /*
         * Find the drawer again before building
         * the section-rendering request.
         */
        this.cart =
          document.querySelector('cart-drawer') ||
          this.cart;

        if (
          this.cart &&
          typeof this.cart.getSectionsToRender ===
            'function'
        ) {
          const sections =
            this.cart
              .getSectionsToRender()
              .map((section) => section.id);

          formData.append(
            'sections',
            sections
          );

          formData.append(
            'sections_url',
            window.location.pathname
          );

          if (
            typeof this.cart.setActiveElement ===
            'function'
          ) {
            this.cart.setActiveElement(
              document.activeElement
            );
          }
        }

        const properties =
          document.querySelectorAll(
            '.product-form__input [name^="properties"]'
          );

        properties.forEach((property) => {
          if (property.type === 'file') {
            if (
              !property.files ||
              property.files.length === 0 ||
              !property.files[0]
            ) {
              return;
            }

            formData.append(
              property.name,
              property.files[0]
            );

            return;
          }

          if (
            property.value == null ||
            property.value === ''
          ) {
            return;
          }

          formData.append(
            property.name,
            property.value
          );
        });

        /*
         * FYOR complimentary gift:
         * Check the current cart before the add request, then add the
         * selected product and the gift together in ONE cart/add call.
         * The drawer receives one final section response and opens once.
         */
        const submitCartRequest = async () => {
          const selectedVariantId = Number(
            formData.get('id')
          );

          const selectedQuantity = Math.max(
            1,
            Number(formData.get('quantity') || 1)
          );

          const hasFileUpload = Array.from(
            formData.values()
          ).some((value) => value instanceof File);

          /*
           * File-upload products must keep FormData.
           * For normal products, use the faster combined JSON request.
           */
          if (
            hasFileUpload ||
            selectedVariantId === FYOR_GIFT_VARIANT_ID
          ) {
            config.body = formData;

            const response = await fetch(
              routes.cart_add_url,
              config
            );

            return response.json();
          }

          let giftAlreadyExists = false;

          try {
            const cartResponse = await fetch(
              `${window.Shopify?.routes?.root || '/'}cart.js`,
              {
                method: 'GET',
                credentials: 'same-origin',
                headers: {
                  Accept: 'application/json',
                },
                cache: 'no-store',
              }
            );

            if (cartResponse.ok) {
              const cartState =
                await cartResponse.json();

              giftAlreadyExists =
                Array.isArray(cartState.items) &&
                cartState.items.some(
                  (item) =>
                    Number(item.variant_id) ===
                    FYOR_GIFT_VARIANT_ID
                );
            }
          } catch (cartCheckError) {
            console.warn(
              '[FYOR Gift] Cart check failed:',
              cartCheckError
            );
          }

          const propertiesObject = {};

          for (const [key, value] of formData.entries()) {
            const propertyMatch = key.match(
              /^properties\[(.+)\]$/
            );

            if (
              propertyMatch &&
              value !== '' &&
              !(value instanceof File)
            ) {
              propertiesObject[propertyMatch[1]] =
                value;
            }
          }

          const selectedItem = {
            id: selectedVariantId,
            quantity: selectedQuantity,
          };

          if (
            Object.keys(propertiesObject).length
          ) {
            selectedItem.properties =
              propertiesObject;
          }

          const sellingPlan =
            formData.get('selling_plan');

          if (sellingPlan) {
            selectedItem.selling_plan =
              Number(sellingPlan);
          }

          const items = [selectedItem];

          if (!giftAlreadyExists) {
            items.push({
              id: FYOR_GIFT_VARIANT_ID,
              quantity: 1,
              properties: {
                [FYOR_GIFT_PROPERTY_NAME]:
                  'true',
              },
            });
          }

          const sectionIds =
            this.cart &&
            typeof this.cart
              .getSectionsToRender ===
              'function'
              ? this.cart
                  .getSectionsToRender()
                  .map((section) => section.id)
              : [
                  'cart-drawer',
                  'cart-icon-bubble',
                ];

          const response = await fetch(
            routes.cart_add_url,
            {
              ...fetchConfig('json'),
              body: JSON.stringify({
                items,
                sections: sectionIds,
                sections_url:
                  window.location.pathname,
              }),
            }
          );

          return response.json();
        };

        submitCartRequest()
          .then((response) => {
            if (response.status) {
              publish(
                PUB_SUB_EVENTS.cartError,
                {
                  source:
                    'product-form-component',
                  productVariantId:
                    formData.get('id'),
                  errors:
                    response.errors ||
                    response.description,
                  message:
                    response.message,
                }
              );

              this.handleErrorMessage(
                response.description
              );

              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );

              if (!soldOutMessage) return;

              this.submitButton.setAttribute(
                'aria-disabled',
                true
              );

              this.submitButtonText?.classList.add(
                'hidden'
              );

              soldOutMessage.classList.remove(
                'hidden'
              );

              this.error = true;
              return;
            }

            /*
             * Find the live drawer after the
             * add-to-cart response.
             */
            this.cart =
              document.querySelector(
                'cart-drawer'
              ) || this.cart;

            if (!this.cart) {
              console.warn(
                '[Ella Product Form] Cart drawer was not found. Confirm that Theme Settings > Cart type is set to Drawer and that the Cart Drawer section is enabled.'
              );

              window.location =
                window.routes?.cart_url ||
                routes.cart_url;

              return;
            }

            if (!this.error) {
              publish(
                PUB_SUB_EVENTS.cartUpdate,
                {
                  source:
                    'product-form-component',
                  productVariantId:
                    formData.get('id'),
                  cartData: response,
                }
              );
            }

            this.error = false;

            const quickAddModal =
              this.closest(
                'quick-add-modal'
              );

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart =
                      document.querySelector(
                        'cart-drawer'
                      ) || this.cart;

                    if (
                      this.cart &&
                      typeof this.cart
                        .renderContents ===
                        'function'
                    ) {
                      this.cart.renderContents(
                        response
                      );
                    }
                  });
                },
                {
                  once: true,
                }
              );

              quickAddModal.hide(true);
            } else {
              this.cart =
                document.querySelector(
                  'cart-drawer'
                ) || this.cart;

              if (
                this.cart &&
                typeof this.cart
                  .renderContents ===
                  'function'
              ) {
                this.cart.renderContents(
                  response
                );
              }
            }
          })
          .catch((error) => {
            console.error(
              '[Product Form] Add to cart failed:',
              error
            );

            this.handleErrorMessage(
              'Unable to add this product. Please try again.'
            );
          })
          .finally(() => {
            this.submitButton.classList.remove(
              'loading'
            );

            if (!this.error) {
              this.submitButton.removeAttribute(
                'aria-disabled'
              );
            }

            loadingSpinner?.classList.add(
              'hidden'
            );

            const currentProductInfo =
              this.closest('product-info');

            const currentSectionId =
              currentProductInfo?.dataset.section ||
              currentProductInfo?.dataset
                .originalSection;

            const currentStickyButton =
              currentSectionId
                ? document.getElementById(
                    `StickyCart-ProductSubmitButton-${currentSectionId}`
                  )
                : null;

            const currentStickySpinner =
              currentStickyButton?.querySelector(
                '.loading__spinner'
              );

            if (
              currentStickyButton &&
              currentStickySpinner
            ) {
              currentStickyButton.classList.remove(
                'loading'
              );

              currentStickySpinner.classList.add(
                'hidden'
              );
            }
          });
      }

      disconnectedCallback() {
        try {
          this.cartErrorUnsubscriber?.();
          this._errorObserver?.disconnect();
        } catch (error) {
          console.warn(
            '[Product Form] Cleanup failed:',
            error
          );
        }
      }

      handleErrorMessage(
        errorMessage = false
      ) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) {
          return;
        }

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (
          errorMessage &&
          this.errorMessage
        ) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }

      toggleSubmitButton(
        disable = true,
        text
      ) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (
            text &&
            this.submitButtonText
          ) {
            this.submitButtonText.textContent =
              text;
          }
        } else {
          this.submitButton.removeAttribute(
            'disabled'
          );

          if (this.submitButtonText) {
            this.submitButtonText.textContent =
              window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector(
          '[name="id"]'
        );
      }
    }
  );
}